/* assets/rbk-l3.js — PDP Layout 3 horizontal-pan gallery.
   Translates vertical page-scroll into a SEQUENTIAL reveal, driven by a native scroll
   listener (NOT ScrollTrigger — see note below), with the .rbk-l3-stage held by CSS
   position:sticky:
     phase 1 — the info panel scrolls through ALL its content (JS scrollTop),
     phase 2 — the image strip pans left→right in full,
     then the sticky stage releases and the rest of the PDP scrolls on.
   Region height = viewport + infoDistance + panDistance (the two phases are summed,
   not max'd) so neither phase is skipped. Both sub-variants (a and b) use this exact
   model — b only differs visually (In-Stock badge + pinned full-bleed ADD TO BAG bar).

   Why a plain scroll listener, not GSAP ScrollTrigger: this PDP also renders an
   editorial/lore block whose GSAP init calls ScrollTrigger.killAll() AFTER us, which
   silently removed our pan trigger (verified live). A listener we own survives that.

   Desktop only. Bails on touch / reduced-motion — the CSS then lays the track out as a
   normal horizontal-scroll strip so images stay reachable. */
(function () {
  if (window.__rbkL3Init) return;
  window.__rbkL3Init = true;

  function start() {
    var root = document.querySelector('[data-rbk-l3]');
    if (!root) return;

    /* Variant 'b' differs only VISUALLY: green In-Stock badge + a full-bleed ADD TO BAG
       bar pinned at the panel bottom (built below as a flex column inside the form). The
       SCROLL model is identical for a and b — both are page-driven + sequential. In b the
       JS-scrolled element is the inner .rbk-l3b-content (the ATC bar is its fixed sibling);
       in a it's the whole .rbk-l3-info-scroll. */
    var isB = (root.getAttribute('data-l3-variant') === 'b');

    // Guards: desktop pointer + motion ok.
    var mqDesktop = window.matchMedia('(min-width: 768px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    if (!mqDesktop.matches || reduce || coarse) return;

    /* `root` (the <single-product>) is BOTH the JS hook and the tall scroll region.
       We set its height to 100vh + (info + pan); the inner .rbk-l3-stage is sticky
       (CSS) and holds the gallery + info row in place while the track pans. */
    var pin = root;            // the tall region whose height JS controls
    var viewport = root.querySelector('.rbk-l3-viewport');
    var track = root.querySelector('[data-rbk-l3-track]');
    var slides = root.querySelectorAll('[data-rbk-l3-slide]');
    var progress = root.querySelector('[data-rbk-l3-progress]');
    var prevBtn = root.querySelector('[data-rbk-l3-prev]');
    var nextBtn = root.querySelector('[data-rbk-l3-next]');
    if (!pin || !viewport || !track || !slides.length) return;

    var infoScroll = root.querySelector('.rbk-l3-info-scroll');

    /* ---- 3b: pin ADD TO BAG full-bleed at the panel bottom ----
       Verified live: `position: sticky` cannot pin the ATC, because it's the LAST child
       of the <form> (a bottom-sticky last-child is a no-op — nothing scrolls it down).
       The working structure is a flex column INSIDE the form: a scrollable content
       wrapper (flex:1) + the ATC bar (flex:0 0 auto) pinned at the bottom. We build that
       wrapper here in JS (keeping the ATC inside the form, so cart/Pixel wiring survives)
       rather than restructuring the shared Liquid. */
    if (isB) {
      var pinfo = root.querySelector('.rbk-l3-info .product-page-info');
      var form = pinfo && pinfo.querySelector('form');
      var atcBar = pinfo && pinfo.querySelector('.product-page-info__button-add-to-cart');
      // The ATC's wrapper inside the form (Shella's .pb-15 holder, or the ATC block itself).
      var atcHolder = atcBar && (atcBar.closest('[data-js-footbar-product-limit]') || atcBar.parentElement);
      if (form && atcHolder && form.contains(atcHolder) && !form.querySelector('.rbk-l3b-content')) {
        var content = document.createElement('div');
        content.className = 'rbk-l3b-content';
        // Move EVERY visible form child except the ATC holder into the scroll wrapper —
        // both BEFORE and AFTER the ATC (the guarantee accordions sit after it). Leave
        // hidden <input>/<script>/<style> in the form (no layout impact). Result: form
        // is [content (scrolls, flex:1)] + [ATC bar (flex:0, pinned bottom)].
        var kids = Array.prototype.slice.call(form.children);
        for (var k = 0; k < kids.length; k++) {
          var node = kids[k];
          if (node === atcHolder) continue;
          if (node.tagName === 'INPUT' || node.tagName === 'SCRIPT' || node.tagName === 'STYLE') continue;
          content.appendChild(node);            // collects pre- AND post-ATC content
        }
        form.appendChild(content);              // content first in flow…
        form.appendChild(atcHolder);            // …ATC last → pinned at the bottom
        atcHolder.classList.add('rbk-l3b-atcbar');  // CSS hook: the full-bleed bottom bar
        form.classList.add('rbk-l3b-form');     // CSS hook: makes the form a flex column
      }
    }

    /* The element JS scrolls in phase 1. In b that's the inner content wrapper (the ATC
       bar is its pinned sibling, so it must NOT scroll); in a it's the whole panel. */
    var infoScrollEl = isB ? (root.querySelector('.rbk-l3b-content') || infoScroll) : infoScroll;

    function panDistance() {
      // How far the track must travel so the LAST slide's right edge reaches the
      // viewport's right edge.
      return Math.max(0, track.scrollWidth - viewport.clientWidth);
    }
    function infoDistance() {
      // How far the info content must scroll to reveal everything (all accordions).
      return infoScrollEl ? Math.max(0, infoScrollEl.scrollHeight - infoScrollEl.clientHeight) : 0;
    }

    /* SEQUENTIAL, LENIS-DRIVEN (no ScrollTrigger, no GSAP pin, no DOM moves).
       We drive the reveal directly off the page scroll position rather than a
       ScrollTrigger, because this PDP ALSO renders an editorial/lore block whose GSAP
       init calls ScrollTrigger.killAll() AFTER us — which silently removed our pan
       trigger (verified live: our trigger was built, region height set, then absent
       from getAll(), while a manually re-created one survived). A Lenis 'scroll'
       listener we own cannot be killed by that, so it's the robust home for the pan.

       Region height = viewport + info + pan. As the page scrolls through
       [startY, startY + span] (span = info + pan):
         s = prog * span
         phase 1 (s ≤ info): infoScrollEl.scrollTop = s, images held       → reveal panel
         phase 2 (s > info): info pinned at bottom, track.x = -(s - info)   → pan images
       So you read the whole panel first; only once it bottoms out do the images pan;
       only once THEY finish does the page scroll on. Info moves via scrollTop (NOT DOM
       relocation) so the ATC stays inside its <form> — cart/Pixel wiring untouched. */
    var pan = 0, info = 0, hold = 0, span = 0, startY = 0;
    var INFO_START = 0.8;   // the info panel only BEGINS scrolling at 80% of the image pan
                            // (50% read as premature in testing; near the end feels right)
    function measure() {
      pan = panDistance();
      info = infoDistance();
      // HOLD: after the pan finishes, keep the fully-revealed last image pinned for a
      // beat before the page releases. Without it the last image only reaches flush at
      // the exact instant the stage unsticks, so it flashes past and never reads as
      // "fully revealed". ~0.45 viewport of dwell fixes that.
      hold = pan > 0 ? Math.round(window.innerHeight * 0.45) : 0;
      // span = pan + hold. The IMAGES are the master timeline; the info scroll OVERLAPS
      // the pan's second half (it adds no scroll length of its own) — so you scrub the
      // images first and the panel only starts moving once you're midway through them.
      span = pan + hold;
      // root's absolute top in the document (root itself isn't sticky, so this is stable).
      startY = Math.max(0, Math.round(root.getBoundingClientRect().top + (window.pageYOffset || 0)));
      pin.style.height = span > 0 ? (window.innerHeight + span) + 'px' : '';
    }
    function applyProg(prog) {
      var s = prog * span;
      var panPart = Math.min(pan, s);                    // pan is master: completes at s=pan, then holds
      var panProg = pan > 0 ? panPart / pan : 0;         // 0 → 1 across the image strip
      // Info stays put until the pan is halfway (INFO_START), then scrolls to its bottom
      // exactly as the pan finishes — both resolve together, then the hold dwells.
      var infoProg = Math.min(1, Math.max(0, (panProg - INFO_START) / (1 - INFO_START)));
      if (infoScrollEl && info > 0) infoScrollEl.scrollTop = info * infoProg;
      track.style.transform = 'translate3d(' + (-panPart) + 'px,0,0)';
      if (progress) progress.style.width = (panProg * 100).toFixed(2) + '%';
    }
    function onScroll() {
      if (span <= 0) return;
      // Read the REAL scroll position. Lenis drives real scroll (it calls window.scrollTo
      // each frame), so pageYOffset already IS the smoothed position — no need to read
      // lenis.scroll, which goes stale when Lenis's rAF pauses (e.g. backgrounded tab).
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var prog = Math.min(1, Math.max(0, (y - startY) / span));
      applyProg(prog);
    }

    // JS owns the info scroll while active — lock the panel from native wheel scroll.
    if (infoScrollEl) infoScrollEl.style.overflow = 'hidden';
    track.style.willChange = 'transform';
    track.style.transition = 'none';
    measure();
    onScroll();
    // Native 'scroll' covers both native and Lenis (real-scroll) modes, and survives any
    // ScrollTrigger.killAll the lore block performs.
    window.addEventListener('scroll', onScroll, { passive: true });

    // Re-measure on resize and after images decode (both change pan/info distances).
    var rt;
    function remeasure() { measure(); onScroll(); }
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(remeasure, 150); });
    var imgs = root.querySelectorAll('.rbk-l3-img');
    var pending = imgs.length;
    imgs.forEach(function (img) {
      if (img.complete) { if (--pending === 0) remeasure(); }
      else img.addEventListener('load', function () { if (--pending === 0) remeasure(); }, { once: true });
    });
    // Late shifts: full load (all assets) and webfont swap both change the info-content
    // height (→ infoDistance) and the track width (→ panDistance). Re-measure after each.
    window.addEventListener('load', remeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);

    /* ---- Arrows: step one slide ----
       Convert the desired track-x into a scroll position and let Lenis/native scroll
       glide there, so the pin animation follows naturally. */
    function slideStarts() {
      // x-offset of each slide's left edge within the track.
      var xs = [], acc = 0;
      slides.forEach(function (s) { xs.push(acc); acc += s.getBoundingClientRect().width; });
      return xs;
    }
    function scrollToTrackX(targetX) {
      if (span <= 0) return;
      // The pan is phase 2, so a track-x maps to a page-scroll position PAST the info
      // phase: y = startY + info + clampedPan.
      var clamped = Math.min(Math.max(targetX, 0), pan);
      var y = startY + clamped;   // pan now starts at the region top (no info offset)
      var L = window.__lenis;
      if (L && typeof L.scrollTo === 'function') L.scrollTo(y);
      else window.scrollTo({ top: y, behavior: 'smooth' });
    }
    function currentTrackX() {
      var m = /matrix.*?,\s*([-0-9.]+),\s*[-0-9.]+\)$/.exec(getComputedStyle(track).transform);
      return m ? Math.abs(parseFloat(m[1])) : 0;
    }
    function step(dir) {
      var xs = slideStarts();
      var cur = currentTrackX();
      var target = xs[0];
      if (dir > 0) { for (var i = 0; i < xs.length; i++) { if (xs[i] > cur + 2) { target = xs[i]; break; } target = xs[xs.length - 1]; } }
      else { for (var j = xs.length - 1; j >= 0; j--) { if (xs[j] < cur - 2) { target = xs[j]; break; } target = xs[0]; } }
      scrollToTrackX(target);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    /* ---- Hold & drag to swipe (desktop) ----
       Dragging horizontally over the gallery drives the SAME page scroll that pans the
       images, so it never desyncs from the scroll-driven pan. Drag left → scroll down →
       pan forward, 1:1 (1px scroll = 1px pan through the pan range). A tiny click (<4px)
       is ignored so taps/arrow clicks still behave. */
    // No extra pointer gate here: start() already bailed on coarse pointers / non-desktop,
    // so reaching this code means a mouse/pen desktop. (CSS hides the native cursor only
    // under hover:hover + pointer:fine, so the swipe label replaces it on real desktops.)
    var dragging = false, dragStartX = 0, dragStartScroll = 0, dragMoved = false;
    function curScroll() { return window.pageYOffset || document.documentElement.scrollTop || 0; }
    function dragTo(y) {
      y = Math.max(startY, Math.min(startY + span, y));
      // Apply the pan IMMEDIATELY from the target (Lenis's scrollTo updates pageYOffset on
      // the next frame, so don't route through onScroll mid-drag — drive applyProg here)…
      applyProg(span > 0 ? (y - startY) / span : 0);
      // …and move the real page scroll so releasing the drag is seamless.
      var L = window.__lenis;
      if (L && typeof L.scrollTo === 'function') L.scrollTo(y, { immediate: true });
      else window.scrollTo(0, y);
    }
    function onDragDown(e) {
      if (e.button !== undefined && e.button !== 0) return;   // primary button only
      if (span <= 0) return;
      dragging = true; dragMoved = false;
      dragStartX = e.clientX; dragStartScroll = curScroll();
      try { viewport.setPointerCapture(e.pointerId); } catch (_) {}
      document.body.classList.add('rbk-l3-dragging');
    }
    function onDragMove(e) {
      if (!dragging) return;
      var dx = e.clientX - dragStartX;
      if (Math.abs(dx) > 3) dragMoved = true;
      e.preventDefault();                       // kill native image ghost-drag / selection
      dragTo(dragStartScroll - dx);             // drag left (dx<0) → scroll down → pan forward
    }
    function onDragUp(e) {
      if (!dragging) return;
      dragging = false;
      document.body.classList.remove('rbk-l3-dragging');
      try { viewport.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    viewport.addEventListener('pointerdown', onDragDown);
    viewport.addEventListener('pointermove', onDragMove);
    viewport.addEventListener('pointerup', onDragUp);
    viewport.addEventListener('pointercancel', onDragUp);

    /* ---- Custom "swipe" cursor ----
       A circular label that follows the mouse over the gallery (native cursor hidden by
       CSS). Outer node carries the position (JS transform); the inner dot carries the
       scale/opacity transitions so the two never fight. */
    var cursorEl = document.createElement('div');
    cursorEl.className = 'rbk-l3-cursor';
    cursorEl.setAttribute('aria-hidden', 'true');
    cursorEl.innerHTML = '<span class="rbk-l3-cursor-dot"><span>swipe</span></span>';
    root.appendChild(cursorEl);
    function moveCursor(e) {
      cursorEl.style.transform = 'translate3d(' + e.clientX + 'px,' + e.clientY + 'px,0)';
    }
    viewport.addEventListener('pointerenter', function () { cursorEl.classList.add('is-visible'); });
    viewport.addEventListener('pointerleave', function () { cursorEl.classList.remove('is-visible'); });
    viewport.addEventListener('pointermove', moveCursor);
  }

  // Boot: no external-library dependency anymore (the pan is a native scroll listener),
  // so just run once the DOM is parsed.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
